//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import constant from '~/const';

import tableConfig from './tableConfig';

export default {
  data() {
    return {
      tableConfig,
      constant,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('cryptomatsAtms', ['atms', 'atmLimits', 'page', 'pages', 'filters']),
  },

  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
    ]),
    ...mapActions('cryptomatsAtms', {
      loadAtms: 'loadAtms',
      loadAtmLimits: 'loadAtmLimits',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadAtmLimits(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },
  },
};
